import React, { Component } from 'react'
import { connect } from 'react-redux'
import SearchModal from 'bisu-react-search-modal'

import SearchResults from './search-results'
import { searchStudent } from './actions'

class SearchStudent extends Component {

  _onSearch = (term) => {
    this.props.dispatch(searchStudent(term))
  }

  render() {
    const { handleClose, isOpen, linkBase, __results } = this.props

    return (
      <SearchModal
        placeholder="Search Student ID or Last Name"
        handleClose={handleClose}
        onSubmit={this._onSearch}
        isOpen={isOpen}
      >
        <SearchResults results={__results} linkBase={linkBase} />
      </SearchModal>
    )
  }
}

function mapStateToProps(state) {
  return {
    __results: state.student.get('searchResults'),
  }
}

export default connect(mapStateToProps)(SearchStudent)



// WEBPACK FOOTER //
// ./src/containers/Students/search-student.js